export const magnitudes = ['significant', '4.5', '2.5', '1.0', 'all'];
export const periods = ['hour', 'day', 'week', 'month'];
export const sortBy = [
  'greatest magnitude',
  'newest first',
  'greatest significance',
  'shallowest depth',
];
export const mapElementsLimit = 750;
export const defaultValues = {
  country: {
    key: 'PH',
    latitude: 12.879721,
    longitude: 121.774017,
    name: 'Philippines',
  },
  magnitude: '4.5',
  period: 'day',
  mapOptions: {
    zoom: 5,
    maxZoom: 12,
    minZoom: 3,
  },
};

export const sampleQuakes = [
  {
    type: 'Feature',
    properties: {
      mag: 5,
      place: '285 km SSE of Port Blair, India',
      time: 1750770743526,
      updated: 1750771794040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8f3',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8f3.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 385,
      net: 'us',
      code: '7000q8f3',
      ids: ',us7000q8f3,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 80,
      dmin: 5.073,
      rms: 0.77,
      gap: 66,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 5.0 - 285 km SSE of Port Blair, India',
    },
    geometry: {
      type: 'Point',
      coordinates: [94.0138, 9.4122, 10],
    },
    id: 'us7000q8f3',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.6,
      place: '280 km SSE of Port Blair, India',
      time: 1750769599526,
      updated: 1750772724040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8f1',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8f1.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 326,
      net: 'us',
      code: '7000q8f1',
      ids: ',us7000q8f1,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 52,
      dmin: 5.137,
      rms: 0.4,
      gap: 123,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.6 - 280 km SSE of Port Blair, India',
    },
    geometry: {
      type: 'Point',
      coordinates: [93.8621, 9.3818, 10],
    },
    id: 'us7000q8f1',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.9,
      place: '282 km SSE of Port Blair, India',
      time: 1750760218619,
      updated: 1750763876040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8ea',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8ea.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 369,
      net: 'us',
      code: '7000q8ea',
      ids: ',us7000q8ea,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 124,
      dmin: 5.116,
      rms: 0.52,
      gap: 43,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 4.9 - 282 km SSE of Port Blair, India',
    },
    geometry: {
      type: 'Point',
      coordinates: [93.8933, 9.3789, 10],
    },
    id: 'us7000q8ea',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.6,
      place: 'Nicobar Islands, India region',
      time: 1750755855096,
      updated: 1750762314040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8dz',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8dz.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 326,
      net: 'us',
      code: '7000q8dz',
      ids: ',us7000q8dz,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 60,
      dmin: 4.901,
      rms: 0.53,
      gap: 49,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.6 - Nicobar Islands, India region',
    },
    geometry: {
      type: 'Point',
      coordinates: [93.8919, 9.1055, 10],
    },
    id: 'us7000q8dz',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.5,
      place: '93 km NNW of Tatsugō, Japan',
      time: 1750751649921,
      updated: 1750752926040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8dm',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8dm.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 312,
      net: 'us',
      code: '7000q8dm',
      ids: ',us7000q8dm,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 31,
      dmin: 2.441,
      rms: 0.52,
      gap: 108,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.5 - 93 km NNW of Tatsugō, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.3311, 29.2614, 10],
    },
    id: 'us7000q8dm',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.7,
      place: 'south of the Fiji Islands',
      time: 1750748856365,
      updated: 1750750291040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8df',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8df.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 340,
      net: 'us',
      code: '7000q8df',
      ids: ',us7000q8df,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 98,
      dmin: 5.905,
      rms: 0.79,
      gap: 74,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.7 - south of the Fiji Islands',
    },
    geometry: {
      type: 'Point',
      coordinates: [-179.7548, -23.5474, 552.2],
    },
    id: 'us7000q8df',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5.3,
      place: '102 km NNW of Tatsugō, Japan',
      time: 1750748654585,
      updated: 1750749878040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8dd',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8dd.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 432,
      net: 'us',
      code: '7000q8dd',
      ids: ',us7000q8dd,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 78,
      dmin: 2.368,
      rms: 0.92,
      gap: 94,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 5.3 - 102 km NNW of Tatsugō, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.3271, 29.3428, 10],
    },
    id: 'us7000q8dd',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5,
      place: '175 km SE of Sarangani, Philippines',
      time: 1750746272079,
      updated: 1750747315040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8d2',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8d2.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 385,
      net: 'us',
      code: '7000q8d2',
      ids: ',us7000q8d2,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 78,
      dmin: 1.294,
      rms: 1.08,
      gap: 39,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 5.0 - 175 km SE of Sarangani, Philippines',
    },
    geometry: {
      type: 'Point',
      coordinates: [126.7548, 4.4928, 44.989],
    },
    id: 'us7000q8d2',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.7,
      place: '144 km W of Illapel, Chile',
      time: 1750741678924,
      updated: 1750743543040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8cu',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8cu.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 340,
      net: 'us',
      code: '7000q8cu',
      ids: ',us7000q8cu,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 47,
      dmin: 1.311,
      rms: 1.07,
      gap: 141,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.7 - 144 km W of Illapel, Chile',
    },
    geometry: {
      type: 'Point',
      coordinates: [-72.6887, -31.6275, 10],
    },
    id: 'us7000q8cu',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.9,
      place: '260 km E of Levuka, Fiji',
      time: 1750734835847,
      updated: 1750735977040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8c4',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8c4.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 369,
      net: 'us',
      code: '7000q8c4',
      ids: ',us7000q8c4,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 85,
      dmin: 2.779,
      rms: 0.92,
      gap: 79,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.9 - 260 km E of Levuka, Fiji',
    },
    geometry: {
      type: 'Point',
      coordinates: [-178.2216, -18.0447, 559.531],
    },
    id: 'us7000q8c4',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5.7,
      place: '77 km NNE of Punta Cana, Dominican Republic',
      time: 1750733143620,
      updated: 1750772545909,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/pr2025175000',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/pr2025175000.geojson',
      felt: 1297,
      cdi: 6,
      mmi: 4.181,
      alert: 'green',
      status: 'reviewed',
      tsunami: 0,
      sig: 1100,
      net: 'pr',
      code: '2025175000',
      ids: ',pt25175001,us7000q8bs,pr2025175000,',
      sources: ',pt,us,pr,',
      types: ',dyfi,losspager,moment-tensor,oaf,origin,phase-data,shakemap,',
      nst: 26,
      dmin: 0.7606,
      rms: 0.62,
      gap: 189,
      magType: 'mw',
      type: 'earthquake',
      title: 'M 5.7 - 77 km NNE of Punta Cana, Dominican Republic',
    },
    geometry: {
      type: 'Point',
      coordinates: [-68.1103, 19.2245, 68],
    },
    id: 'pr2025175000',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5.5,
      place: '105 km SE of Kirakira, Solomon Islands',
      time: 1750730321174,
      updated: 1750739029937,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8be',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8be.geojson',
      felt: null,
      cdi: null,
      mmi: 4.467,
      alert: 'green',
      status: 'reviewed',
      tsunami: 0,
      sig: 465,
      net: 'us',
      code: '7000q8be',
      ids: ',us7000q8be,',
      sources: ',us,',
      types: ',losspager,origin,phase-data,shakemap,',
      nst: 51,
      dmin: 3.131,
      rms: 0.98,
      gap: 53,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 5.5 - 105 km SE of Kirakira, Solomon Islands',
    },
    geometry: {
      type: 'Point',
      coordinates: [162.6867, -11.041, 35],
    },
    id: 'us7000q8be',
  },
  {
    type: 'Feature',
    properties: {
      mag: 6.2,
      place: 'east of the Philippine Islands',
      time: 1750730285961,
      updated: 1750752624835,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8bd',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8bd.geojson',
      felt: 14,
      cdi: 3.4,
      mmi: 0,
      alert: 'green',
      status: 'reviewed',
      tsunami: 0,
      sig: 596,
      net: 'us',
      code: '7000q8bd',
      ids: ',us7000q8bd,',
      sources: ',us,',
      types: ',dyfi,losspager,moment-tensor,origin,phase-data,shakemap,',
      nst: 174,
      dmin: 4.34,
      rms: 0.74,
      gap: 34,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 6.2 - east of the Philippine Islands',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.8586, 7.9876, 5],
    },
    id: 'us7000q8bd',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.8,
      place: '59 km SSW of Vinchina, Argentina',
      time: 1750729995978,
      updated: 1750731095040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8bc',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8bc.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 354,
      net: 'us',
      code: '7000q8bc',
      ids: ',us7000q8bc,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 60,
      dmin: 1.666,
      rms: 1.04,
      gap: 28,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 4.8 - 59 km SSW of Vinchina, Argentina',
    },
    geometry: {
      type: 'Point',
      coordinates: [-68.355, -29.2802, 45.766],
    },
    id: 'us7000q8bc',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.5,
      place: '72 km SSW of Vanimo, Papua New Guinea',
      time: 1750720893377,
      updated: 1750741392040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8aq',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8aq.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 312,
      net: 'us',
      code: '7000q8aq',
      ids: ',us7000q8aq,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 9,
      dmin: 0.878,
      rms: 0.28,
      gap: 206,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.5 - 72 km SSW of Vanimo, Papua New Guinea',
    },
    geometry: {
      type: 'Point',
      coordinates: [141.0943, -3.3066, 10],
    },
    id: 'us7000q8aq',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.6,
      place: '14 km ENE of Tournavista, Peru',
      time: 1750719144068,
      updated: 1750738709040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q8ai',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q8ai.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 326,
      net: 'us',
      code: '7000q8ai',
      ids: ',us7000q8ai,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 38,
      dmin: 2.185,
      rms: 0.57,
      gap: 104,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.6 - 14 km ENE of Tournavista, Peru',
    },
    geometry: {
      type: 'Point',
      coordinates: [-74.5784, -8.8943, 142.353],
    },
    id: 'us7000q8ai',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.5,
      place: '118 km SSE of San Pedro de Atacama, Chile',
      time: 1750713016859,
      updated: 1750727388040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q89v',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q89v.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 312,
      net: 'us',
      code: '7000q89v',
      ids: ',us7000q89v,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 23,
      dmin: 1.023,
      rms: 0.56,
      gap: 96,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.5 - 118 km SSE of San Pedro de Atacama, Chile',
    },
    geometry: {
      type: 'Point',
      coordinates: [-67.705, -23.8819, 151.402],
    },
    id: 'us7000q89v',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5.4,
      place: '31 km NNW of Asan-Maina Village, Guam',
      time: 1750706066404,
      updated: 1750771478398,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q89a',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q89a.geojson',
      felt: 12,
      cdi: 3.4,
      mmi: 3.748,
      alert: 'green',
      status: 'reviewed',
      tsunami: 0,
      sig: 453,
      net: 'us',
      code: '7000q89a',
      ids: ',us7000q89a,',
      sources: ',us,',
      types: ',dyfi,losspager,moment-tensor,oaf,origin,phase-data,shakemap,',
      nst: 116,
      dmin: 0.258,
      rms: 0.82,
      gap: 40,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 5.4 - 31 km NNW of Asan-Maina Village, Guam',
    },
    geometry: {
      type: 'Point',
      coordinates: [144.6587, 13.749, 146.001],
    },
    id: 'us7000q89a',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5,
      place: '189 km ESE of Kimbe, Papua New Guinea',
      time: 1750704713530,
      updated: 1750705692040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q896',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q896.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 385,
      net: 'us',
      code: '7000q896',
      ids: ',us7000q896,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 31,
      dmin: 2.03,
      rms: 0.6,
      gap: 152,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 5.0 - 189 km ESE of Kimbe, Papua New Guinea',
    },
    geometry: {
      type: 'Point',
      coordinates: [151.7292, -6.1875, 10],
    },
    id: 'us7000q896',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.5,
      place: 'Fiji region',
      time: 1750701716288,
      updated: 1750710707040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q88u',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q88u.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 312,
      net: 'us',
      code: '7000q88u',
      ids: ',us7000q88u,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 62,
      dmin: 4.402,
      rms: 0.7,
      gap: 123,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.5 - Fiji region',
    },
    geometry: {
      type: 'Point',
      coordinates: [-178.7205, -20.939, 571.324],
    },
    id: 'us7000q88u',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.8,
      place: '85 km S of Kushiro, Japan',
      time: 1750701312877,
      updated: 1750709750040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q88q',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q88q.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 354,
      net: 'us',
      code: '7000q88q',
      ids: ',us7000q88q,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 77,
      dmin: 1.048,
      rms: 0.68,
      gap: 134,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.8 - 85 km S of Kushiro, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [144.54, 42.2121, 33.852],
    },
    id: 'us7000q88q',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5,
      place: '108 km NNW of Tatsugō, Japan',
      time: 1750699409894,
      updated: 1750701881040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us7000q88k',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us7000q88k.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 385,
      net: 'us',
      code: '7000q88k',
      ids: ',us7000q88k,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 30,
      dmin: 2.318,
      rms: 1.31,
      gap: 89,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 5.0 - 108 km NNW of Tatsugō, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.3189, 29.4006, 10],
    },
    id: 'us7000q88k',
  },
  {
    type: 'Feature',
    properties: {
      mag: 5.1,
      place: '106 km N of Tatsugō, Japan',
      time: 1750689379899,
      updated: 1750690552040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us6000qlyq',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us6000qlyq.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 400,
      net: 'us',
      code: '6000qlyq',
      ids: ',us6000qlyq,',
      sources: ',us,',
      types: ',moment-tensor,origin,phase-data,',
      nst: 70,
      dmin: 2.291,
      rms: 1.14,
      gap: 110,
      magType: 'mww',
      type: 'earthquake',
      title: 'M 5.1 - 106 km N of Tatsugō, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.4181, 29.393, 10],
    },
    id: 'us6000qlyq',
  },
  {
    type: 'Feature',
    properties: {
      mag: 4.5,
      place: '94 km NNW of Tatsugō, Japan',
      time: 1750688272816,
      updated: 1750692952040,
      tz: null,
      url: 'https://earthquake.usgs.gov/earthquakes/eventpage/us6000qlyn',
      detail:
        'https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us6000qlyn.geojson',
      felt: null,
      cdi: null,
      mmi: null,
      alert: null,
      status: 'reviewed',
      tsunami: 0,
      sig: 312,
      net: 'us',
      code: '6000qlyn',
      ids: ',us6000qlyn,',
      sources: ',us,',
      types: ',origin,phase-data,',
      nst: 65,
      dmin: 2.424,
      rms: 0.42,
      gap: 107,
      magType: 'mb',
      type: 'earthquake',
      title: 'M 4.5 - 94 km NNW of Tatsugō, Japan',
    },
    geometry: {
      type: 'Point',
      coordinates: [129.3496, 29.2734, 10],
    },
    id: 'us6000qlyn',
  },
];
